
export const intervalOver = (duration, interval, execute, onIntervalDone) => {
    let callCount = 0;
    const maxCallCount = duration / interval;

    // terminates the interval on kill call via terminate
    const terminate = () =>  {
        clearInterval(intervalId);
    };

    // constructs the desired interval
    const intervalId = setInterval(() => {
        callCount++;
        execute?.(terminate);
        if (callCount >= maxCallCount) {
            clearInterval(intervalId);
            onIntervalDone?.();
        }
    }, interval);

    return intervalId;
}

export default {
    intervalOver
}